export default {
    'general': {
        'versioning': 'Verzioniranje',
        'dashboard': 'Nadzorna ploča',
        'email': 'E-pošta',
        'username': 'Korisničko ime',
        'name': 'Ime',
        'password': 'Lozinka',
        'actions': 'Akcije',
        'login': 'Prijava',
        'logout': 'Odjava',
        'no_results': 'Nema rezultata',
        'success': 'Uspjeh',
        'warning': 'Upozorenje',
        'remember_me': 'Zapamti me',
        'error': 'Greška',
        'edit': 'Uredi',
        'details': 'Detalji',
        'add': 'Dodaj',
        'delete': 'Obriši',
        'yes': 'Da',
        'no': 'Ne',
        'cancel': 'Odustani',
        'back': 'Natrag',
        'image': 'Slika',
        'filters': 'Filtri',
        'remove_filters': 'Ukloni filtre',
        'default': 'Zadano',
        'save': 'Spremi',
        'key': 'Ključ',
        'distribution_zone': 'Zona distribucije',
        'preview': 'Pregled',
        'icon': 'Ikona',
        'last_edited': 'Zadnje uređivano',
        'unknown': 'Nepoznato',
        'latest_version': 'Najnovija verzija',
        'taxpayer': 'Porezni obveznik',
        'country': 'Država',
        'date_at': 'u',
        'drag_and_drop_files_to_upload': 'Povucite i ispustite datoteke za prijenos',
        'export': 'Izvoz',
        'options': 'Opcije',
        'download': 'Preuzmi'
    },
    'warning': {
        'file_preview_not_available': 'Pregled nije dostupan za ovu vrstu datoteke.'
    },
    'errors': {
        'generic_error': 'Došlo je do pogreške',
        'login': 'Greška prilikom prijave',
        'logout': 'Greška prilikom odjave',
        'incorrect_password': 'Stara lozinka nije točna',
        'invalid_data': 'Primljeni su nevažeći podaci',
        'not_found': 'Podaci nisu pronađeni',
        'user_exist': 'Korisnik s ovom e-poštom već postoji',
        'load_data': 'Greška pri učitavanju podataka',
        'on_upload_image': 'Greška pri prijenosu slika',
        'on_upload_file': 'Greška pri prijenosu datoteka',
        'on_publish': 'Greška tijekom objavljivanja',
        'on_approve': 'Greška tijekom odobravanja',
        'on_download': 'Greška pri preuzimanju datoteke',
        'on_add': 'Greška pri dodavanju',
        'on_edit': 'Greška pri uređivanju',
        'on_delete': 'Greška pri brisanju',
        'on_sort': 'Greška pri sortiranju',
        'unauthorized': 'Neautorizirano',
        'user_does_not_exist': 'Korisnik ne postoji',
        'country_not_found': 'Država nije pronađena',
        'country_not_specified': 'Država nije navedena',
        'tax_number_not_found': 'Porezni broj nije pronađen',
        'company_with_vat_number_exists': 'Tvrtka s ovim poreznim brojem već postoji',
        'username_exists': 'Ovo korisničko ime već postoji. Molimo koristite drugo.',
        'email_exists': 'Ova e-pošta već postoji. Molimo koristite drugu.',
        'failed_to_insert': 'Neuspjelo umetanje',
        'file_to_big': 'Datoteka je prevelika',
        'missing_roles': 'Nedostaju uloge',
        'no_roles_selected': 'Korisnik mora imati odabranu barem jednu ulogu',
        'fetching_data': 'Greška pri dohvaćanju podataka',
        'deleting_default_data': 'Greška pri brisanju zadanih podataka',
        'data_already_exists': 'Podaci već postoje',
        'unable_to_retrieve_extension': 'Nije moguće dohvatiti ekstenziju',
        'role_exists': 'Uloga već postoji',
        'role_does_not_exist': 'Uloga ne postoji',
        'no_access': 'Nema pristupa'
    },
    'success': {
        'on_add': 'Uspješno dodano',
        'on_edit': 'Uspješno uređeno',
        'on_delete': 'Uspješno obrisano',
        'on_update': 'Uspješno ažurirano',
        'on_remove': 'Uspješno uklonjeno',
        'on_publish': 'Uspješno objavljeno',
        'on_approve': 'Uspješno odobreno',
        'on_sort': 'Uspješno sortirano',
        'on_change_password': 'Lozinka je uspješno promijenjena',
        'channel_package_activated': 'Paket kanala uspješno aktiviran',
        'channel_package_deactivated': 'Paket kanala uspješno deaktiviran'
    },
    'confirmations': {
        'general': 'Jeste li sigurni da želite nastaviti?',
        'header': 'Jeste li sigurni',
        'delete_row': 'Jeste li sigurni da želite obrisati',
        'deactivate_row': 'Jeste li sigurni da želite deaktivirati',
        'publish': 'Jeste li sigurni da želite objaviti na',
        'approve': 'Jeste li sigurni da želite odobriti'
    },
    'table': {
        'no_data': 'Nema podataka za prikaz',
        'press_enter_search': 'Pritisnite enter za pretragu',
        'search': 'Traži po',
        'select_option': 'Odaberite opciju',
        'select_date': 'Odaberite datum',
        'select_range': 'Odaberite raspon',
        'of': 'od'
    },
    'file': {
        'drag_and_drop': 'Povucite i ispustite datoteke ovdje za prijenos.'
    },
    'comment': {
        'reply': 'Odgovori',
        'replies': 'Odgovori',
        'show_more_replies': 'Prikaži više odgovorov',
        'show_replies': 'Prikaži odgovore',
        'hide_replies': 'Sakrij odgovore',
        'attachments': 'Privitci',
        'comment': 'Komentar',
        'comments': 'Komentari',
        'edited': 'uređeno',
        'deleted': 'Komentar izbrisan',
        'deleted_at': 'Izbrisano',
        'delete': 'comment',
        'attachment': 'Privitak',
        'add_comment': 'Dodajte komentar',
        'add_comment_text': 'Dodajte komentar (koristite {\'@\'} za spominjanje)'
    },
    'language': {
        'slovenian': 'Slovenski',
        'english': 'Engleski',
        'croatian': 'Hrvatski'
    },
    'signature': {
        'signature': 'Potpis',
        'sign': 'Potpiši',
        'cancel': 'Odustani',
        'clear': 'Očisti'
    },
    'lead': {
        'lead': 'Prilika',
        'leads': 'Prilike',
        'add': 'Dodaj priliku',
        'priority': 'Prioritet',
        'save': 'Spremi',
        'project_milestones': 'Prekretnice projekta',
        'hide_devices_page': 'Ne prikaži stranicu s uređajima',
        'devices_page_shown': 'Prikaz stranice s uređajima',
        'company': {
            'add': 'Dodaj tvrtku',
            'edit': 'Uredi podatke tvrtke',
            'does_not_exist': 'Tvrtka ne postoji',
            'select': 'Odaberi tvrtku',
            'company': 'Tvrtka'
        },
        'active_seller': {
            'edit': 'Uredi aktivnog prodavača'
        },
        'maintenance_worker': {
            'edit': 'Uredi servisera'
        },
        'contact': {
            'add': 'Dodaj kontakt',
            'select': 'Odaberi kontakt',
            'info': 'Informacije o kontaktu',
            'contact': 'Kontakt',
            'contact_information': 'Kontakt informacije'
        },
        'business_unit': {
            'business_unit': 'Poslovna jedinica',
            'business_units': 'Poslovne jedinice',
            'add_new': 'Dodaj novu poslovnu jedinicu',
            'created': 'Stvoreno',
            'last_edited': 'Zadnje uređivano',
            'select': 'Odaberi',
            'business_unit_select': 'Odabir poslovne jedinice',
            'edit': 'Uredi',
            'edit_business_unit': 'Uredi poslovnu jedinicu',
            'remove': 'Ukloni',
            'status': 'STATUS',
            'name': 'Ime',
            'address': 'Adresa',
            'add': 'Dodaj poslovnu jedinicu',
            'primary_activity': 'Primarna djelatnost',
            'view': 'Pregledaj'
        },
        'status': {
            'status': 'Status prilike',
            'draft': 'Nacrt',
            'offer_sent': 'Ponuda poslana',
            'data_retrieval': 'Preuzimanje podataka',
            'data_entry': 'Unos podataka',
            'installation': 'Instalacija',
            'rejected': 'Odbijeno',
            'additional_requirements': 'Dodatni zahtjevi',
            'completed': 'Dovršeno',
            'rejection_reason': 'Razlog odbijanja',
            'reject': 'Odbij',
            'empty': 'PRAZNO',
            'started': 'ZAPOČETO',
            'finished': 'ZAVRŠENO'
        },
        'tasks': {
            'contact_request': 'Zahtjev za kontakt',
            'presentation_to_client': 'Prezentacija klijentu',
            'requirements_analysis': 'Analiza zahtjeva',
            'offer_and_contract_prepare': 'Priprema ponude i ugovora',
            'offer_and_contract_presentation': 'Prezentacija ponude i ugovora',
            'estimated_finish_date': 'Predviđeni datum završetka',
            'estimated_finish': 'Predviđeni završetak',
            'finished': 'Završeno',
            'not_finished': 'Nije završeno',
            'tasks': 'Zadaci',
            'mark_as_finished': 'Označi kao završeno',
            'mark_as_not_finished': 'Označi kao nezavršeno'
        },
        'software_offer': {
            'software_offer': 'Ponuda softvera',
            'licence': 'Licenca',
            'discount': 'Popust',
            'desktop_devices': 'Stolna računala',
            'mobile_devices': 'Mobilni uređaji',
            'number_of_products': 'Broj proizvoda',
            'number_of_ingredients': 'Broj sastojka',
            'payment_type': 'Vrsta plaćanja',
            'payment_month': 'Mjesec plaćanja',
            'payment_frequency': 'Učestalost plaćanja',
            'wolt_integration_enabled': 'Wolt integracija omogućena',
            'return_packaging_integration_enabled': 'Integracija povratne ambalaže omogućena',
            'installation_option': 'Možnost namestitve',
            'installation_price': 'Cijena instalacije',
            'option': {
                'according_to_price_list': 'Po cjeniku',
                'discount_100_percentages': '100% popusta',
                'hide_table_on_offer': 'Sakrij tablico u ponudi',
                'custom_price': 'Prilagođena cijena'
            },
            'software': 'Softver',
            'imprion_pos': 'Imprion Blagajna'
        },
        'hardware_offer': {
            'hardware': 'Hardver',
            'client_has_all_hardware': 'Klijent ima sav hardver',
            'hardware_offer': 'Ponuda hardvera',
            'hardware_offers': 'Ponude hardvera',
            'pos_hardware': 'POS hardver',
            'is_custom_hardware': 'Prilagođeni hardver',
            'pos_hardware_custom': 'Prilagođeni POS hardver',
            'quantity': 'Količina',
            'price': 'Cijena',
            'price_per_item': 'Cijena po komadu',
            'price_with_vat': 'Cijena sa PDV',
            'price_with_discount': 'Cijena s popustom',
            'total_price': 'Ukupna cijena',
            'discount': 'Popust',
            'add': 'Dodaj',
            'edit': 'Uredi',
            'cancel': 'Odustani',
            'vat': 'PDV'
        },
        'payment_gateway_status': {
            'payment_gateway_status': 'Status platnog sustava',
            'using_card_payments': 'Korištenje kartičnog plaćanja',
            'current_card_payment_provider': 'Trenutni pružatelj kartičnog plaćanja',
            'custom_card_system': 'Prilagođeni kartični sustav',
            'want_to_use_card_system': 'Želi koristiti kartični sustav',
            'provider': 'Pružatelj'
        },
        'connection_schedule': {
            'connection_schedule': 'Raspored spajanja',
            'connection_type': 'Kada se želite spojiti',
            'connection_date': 'Datum spajanja',
            'connection': 'Spajanje'
        },
        'additional_requests': {
            'additional_requests': 'Dodatni zahtjevi',
            'additional_request': 'Dodatni zahtjev',
            'request': 'Zahtjev',
            'priority': 'Prioritet',
            'add': 'Dodaj',
            'edit': 'Uredi',
            'cancel': 'Odustani'
        },
        'network_infrastructure': {
            'network_infrastructure': 'Mrežna infrastruktura',
            'is_wifi_setup': 'Je li WiFi postavljen',
            'business_unit_wifi_covered': 'Poslovna jedinica pokrivena WiFi-em',
            'is_wifi_stable': 'Je li WiFi stabilan',
            'multiple_ap_in_business_unit': 'Više pristupnih točaka (AP) u poslovnoj jedinici',
            'multiple_ap': 'Više AP-ova',
            'ap_has_roaming': 'AP ima roaming',
            'ap_manufacturer': 'Proizvođač AP-a',
            'ap_manufacturer_custom': 'Prilagođeni proizvođač AP-a',
            'network_manager_type': 'Vrsta mrežnog upravitelja',
            'network_manager': 'Mrežni upravitelj',
            'network_manager_name': 'Ime mrežnog upravitelja',
            'can_devices_sync': 'Mogu li se uređaji sinkronizirati'
        },
        'priority_value': {
            'low': 'Niska',
            'medium': 'Srednja',
            'high': 'Visoka',
            'urgent': 'Hitno',
            'critical': 'Kritično'
        },
        'sale': 'Prodaja',
        'generating_quote': 'Generiranje ponude',
        'printout_of_entered_data': 'Izpis unesenih podataka',
        'create_new_company': 'Stvorite novu tvrtku'
    },
    'editor': {
        'heading': 'Naslov',
        'subheading': 'Podnaslov',
        'subheading_3': 'Podnaslov 3',
        'base': 'Osnovno',
        'bold': 'Podebljano',
        'italic': 'Kurziv',
        'underline': 'Podcrtano',
        'left_align': 'Lijevo',
        'center_align': 'Sredina',
        'right_align': 'Desno',
        'justify_align': 'Obostrano',
        'ordered_list': 'Numerirani popis',
        'bullet_list': 'Popis s grafičkim oznakama',
        'small': 'Malo',
        'normal': 'Normalno',
        'large': 'Veliko',
        'huge': 'Ogromno',
        'link': 'Poveznica'
    },
    'months': {
        'january': 'Siječanj',
        'february': 'Veljača',
        'march': 'Ožujak',
        'april': 'Travanj',
        'may': 'Svibanj',
        'june': 'Lipanj',
        'july': 'Srpanj',
        'august': 'Kolovoz',
        'september': 'Rujan',
        'october': 'Listopad',
        'november': 'Studeni',
        'december': 'Prosinac'
    },
    'licences': {
        'essential': 'Essential',
        'standard': 'Standardno',
        'premium': 'Premium'
    },
    'timelee': {
        'without': 'Bez',
        'basic': 'Osnovno',
        'pro': 'Pro',
        'discount_on_timelee': 'Popust na timelee'
    },
    'payment_frequencies': {
        'monthly': 'Mjesečno',
        'instalment_plan': 'Obročno plaćanje',
        'yearly': 'Godišnje'
    },
    'payment_interval': {
        'payment_interval': 'Interval plaćanja',
        'three_months': 'Svaka 3 mjeseca',
        'four_months': 'Svaka 4 mjeseca',
        'six_months': 'Svakih 6 mjeseci'
    },
    'card_payment_providers': {
        'besteron': 'Besteron',
        'hobex': 'Hobex',
        'wordline': 'Wordline',
        'other': 'Ostalo'
    },
    'connection_types': {
        'asap': 'Što prije',
        'no_preference': 'Bez preferencije',
        'fixed_date': 'Fiksni datum'
    },
    'ap_roaming_types': {
        'yes': 'Da',
        'no': 'Ne',
        'unknown': 'Nepoznato'
    },
    'ap_manufactures': {
        'ubiquiti': 'Ubiquiti',
        'tp_link': 'TP link',
        'tenda': 'Tenda',
        'mikrotik': 'Mikrotik',
        'asus': 'Asus',
        'zyxel': 'Zyxel',
        'd_link': 'D link',
        'cisco': 'Cisco',
        'huawei': 'Huawei',
        'ruijie_reyeea': 'Ruijie-ReyeeA',
        'aruba': 'Aruba',
        'ruckus': 'Ruckus',
        'xirrus': 'Xirrus',
        'cambium': 'Cambium',
        'other': 'Ostalo'
    },
    'network_manager_types': {
        'inner': 'Unutarnji',
        'outer': 'Vanjski'
    },
    'primary_activities': {
        'restaurant': 'Restoran',
        'food_truck': 'Kamion s hranom (Food truck)',
        'hairdresser': 'Frizerski salon',
        'beauty_salon': 'Kozmetički salon',
        'other_service_activity': 'Ostale uslužne djelatnosti',
        'other': 'Ostalo'
    },
    'company': {
        'company': 'Tvrtka | Tvrtke',
        'company_that_not_exists': 'Tvrtka koja ne postoji | Tvrtke koje ne postoje',
        'add': 'Dodaj tvrtku',
        'edit': 'Uredi tvrtku',
        'official_name': 'Službeni naziv',
        'alias': 'Alias',
        'country': 'Država',
        'country_name': 'Ime države',
        'country_code': 'Kod države',
        'tax_number': 'OIB / Porezni broj',
        'address': 'Adresa',
        'is_tax_payer': 'Porezni obveznik',
        'contact': {
            'title': 'Kontakt tvrtke | Kontakti tvrtke',
            'add': 'Dodaj kontakt tvrtke',
            'edit': 'Uredi kontakt tvrtke',
            'first_name': 'Ime',
            'last_name': 'Prezime',
            'email': 'E-pošta',
            'phone_number': 'Broj telefona',
            'company_role': 'Uloga u tvrtki'
        }
    },
    'business_unit': {
        'business_unit': 'Poslovna jedinica | Poslovne jedinice',
        'add': 'Dodaj poslovnu jedinicu',
        'edit': 'Uredi poslovnu jedinicu',
        'primary_activity': 'Primarna djelatnost',
        'movable': 'Pokretno',
        'is_movable': 'Je pokretno',
        'activity': {
            'catering_establishment': 'Ugostiteljski objekt',
            'food_truck': 'Food truck',
            'hair_salon': 'Frizerski salon',
            'beauty_salon': 'Kozmetički salon',
            'other_service_activity': 'Ostale uslužne djelatnosti',
            'other': 'Ostalo'
        }
    },
    'profile': {
        'profile': 'Profil',
        'edit_profile': 'Uredi profil',
        'old_password': 'Stara lozinka',
        'new_password': 'Nova lozinka',
        'confirm_password': 'Potvrdi lozinku',
        'change_password_text': 'Ako je polje za lozinku prazno, lozinka se neće mijenjati.',
        'change_password': 'Promijeni lozinku'
    },
    'seller': {
        'seller': 'Prodavač | Prodavači',
        'active_seller': 'Aktivan prodavač',
        'maintenance_worker': 'Serviser',
        'add': 'Dodaj prodavača',
        'edit': 'Uredi prodavača',
        'first_name': 'Ime',
        'last_name': 'Prezime',
        'email': 'E-pošta',
        'phone_number': 'Broj telefona',
        'language': 'Jezik',
        'password': 'Lozinka',
        'change_password': 'Promijeni lozinku',
        'new_password': 'Nova lozinka',
        'confirm_password': 'Potvrdi lozinku',
        'role': {
            'role': 'Uloga | Uloge',
            'view_all_leads': 'Pregled svih prilika',
            'reassign_leads': 'Preusmjeri prilike',
            'remove_leads': 'Brisanje prilika',
            'manage_users': 'Upravljanje korisnicima'
        }
    },
    'current_software': {
        'current_software': 'Trenutni softver | Trenutni softver',
        'current_software_custom': 'Prilagođeni Trenutni softver'
    },
    'lead_source': {
        'lead_source': 'Vir prilike | Vir prilika',
        'lead_source_custom': 'Prilagođeni vir prilike'
    },
    'besteron': {
        'payment_data': 'Besteron podaci o plaćanju',
        'company_name': 'Naziv tvrtke',
        'activity': 'Djelatnost',
        'activity_suggestion': '(restoran, trgovina, ...)',
        'activity_custom': 'Unesite djelatnost',
        'pos_terminal_location': 'Lokacija POS terminala',
        'pos_terminal_location_suggestion': 'adresa',
        'location_name': 'Naziv lokacije',
        'location_name_suggestion': 'naziv trgovine, objekta',
        'contact_person': 'Kontakt osoba',
        'email': 'E-mail',
        'email_suggestion': 'gdje će stizati izvodi',
        'phone_number': 'Broj telefona',
        'tax_number': 'Porezni broj (OIB)',
        'registration_number': 'Matični broj',
        'iban': 'IBAN',
        'expected_traffic': 'Očekivani promet',
        'annual_gross_turnover': 'Godišnji bruto promet',
        'gross_card_turnover': 'Bruto kartični promet',
        'one_time_maximum_payment': 'Jednokratno maksimalno plaćanje',
        'average_card_payment': 'Prosječno kartično plaćanje',
        'minimum_transaction_fee': 'Minimalna naknada za transakciju',
        'number_of_pos_terminals': 'Broj POS terminala',
        'owner_of_space_or_tenats': 'Vlasnik prostora / zakupnik',
        'owner_of_space': 'Vlasnik prostora',
        'space_rental': 'Zakup prostora',
        'wifi_or_lte': 'WiFi / LTE',
        'wifi': 'WiFi',
        'lte': 'LTE',
        'purchase_of_terminal_or_rental': 'Kupnja terminala / najam terminala',
        'purchase_of_terminal': 'Kupnja terminala',
        'terminal_rental': 'Najam terminala',
        'personal_card_image': 'Slika osobne kartice',
        'name_of_terminal': 'Naziv terminala',
        'company_data': 'Podaci o tvrtki',
        'turnover': 'Promet',
        'other': 'Ostalo',
        'start_of_billing': 'Početak obračuna',
        'accounting_period': 'Obračunsko razdoblje',
        'daily': 'Dnevno',
        'weekly': 'Tjedno',
        '14_daily': '14-dnevno',
        'monthly': 'Mjesečno',
        'term_terminal': 'Trajanje najma terminala',
        'short_term': 'Kratkoročno',
        'long_term': 'Dugoročno'
    },
    'equipment': {
        'card_payment_equipment': 'Oprema za plaćanje karticama | Oprema za plaćanje karticama',
        'add_card_payment_equipment': 'Dodaj opremu za plaćanje karticama',
        'edit_card_payment_equipment': 'Uredi opremu za plaćanje karticama',
        'color': 'Boja',
        'monthly_price': 'Mjesečna cijena',
        'one_time_price': 'Jednokratna cijena',
        'bought': 'Kupljeno',
        'not_bought': 'Nije kupljeno',
        'provider_name': 'Naziv pružatelja usluga'
    }
}
